import { render, staticRenderFns } from "./Carnival.vue?vue&type=template&id=5e6799c7&scoped=true&"
import script from "./Carnival.vue?vue&type=script&lang=js&"
export * from "./Carnival.vue?vue&type=script&lang=js&"
import style0 from "./Carnival.vue?vue&type=style&index=0&id=5e6799c7&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e6799c7",
  null
  
)

export default component.exports